import './app'
import './templates'
import './commentmodel'
import './commentcollection'
import './commentsummarymodel'
import './commentstabview'
import './commentsmodifymenu'
import './filesplugin'
import './activitytabviewplugin'
import './search'

import './vendor/Caret.js/dist/jquery.caret.min'
import './vendor/At.js/dist/js/jquery.atwho.min'

import './style/autocomplete.scss'
import './style/comments.scss'

window.OCA.Comments = OCA.Comments
